import React from 'react';
import { FileText, Video } from 'lucide-react';
export function Newsletters2021Section() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-3371">
      <div className="bg-[#1874cd] py-4 px-6" data-id="element-3372">
        <h2 className="text-2xl font-bold text-white" data-id="element-3373">Newsletters 2021</h2>
      </div>
      <div className="p-8 space-y-8" data-id="element-3374">
        <ul className="space-y-4" data-id="element-3375">
          <li className="flex items-start" data-id="element-3376">
            <FileText className="h-5 w-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-3377" />
            <a href="https://conta.cc/31RTu4Q" target="_blank" rel="noopener noreferrer" className="text-lg text-gray-700 hover:text-orange font-medium transition-colors" data-id="element-3378">
              Benefits of Twin Wire EDM
            </a>
          </li>
          <li className="flex items-start" data-id="element-3379">
            <FileText className="h-5 w-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-3380" />
            <a href="https://conta.cc/2P07BCj" target="_blank" rel="noopener noreferrer" className="text-lg text-gray-700 hover:text-orange font-medium transition-colors" data-id="element-3381">
              Mikron MILL P 500
            </a>
          </li>
          <li className="flex items-start" data-id="element-3382">
            <FileText className="h-5 w-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-3383" />
            <a href="https://conta.cc/31TpCVz" target="_blank" rel="noopener noreferrer" className="text-lg text-gray-700 hover:text-orange font-medium transition-colors" data-id="element-3384">
              Don't Get Screwed. Get Linear!
            </a>
          </li>
        </ul>

        <div className="pt-6 border-t border-gray-100" data-id="element-3385">
          <h3 className="text-xl font-bold text-navy mb-4" data-id="element-3386">
            Webinars & Events:
          </h3>
          <ul className="space-y-4" data-id="element-3387">
            <li className="flex items-start" data-id="element-3388">
              <Video className="h-5 w-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-3389" />
              <a href="https://conta.cc/3sVrdq3" target="_blank" rel="noopener noreferrer" className="text-lg text-gray-700 hover:text-orange font-medium transition-colors" data-id="element-3390">
                Live! Lase Texturing Shop Floor Tour
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>;
}